package com.islamicmedia.site.pages.isitsafe

import androidx.compose.runtime.Composable
import com.islamicmedia.site.components.PublicReviewPage
import com.varabyte.kobweb.core.Page

/** Public SEO review — "/isitsafe/harry-potter". Pulls the REAL cached analysis from PROD. */
@Page("/isitsafe/harry-potter")
@Composable
fun HarryPotterReviewPage() {
    PublicReviewPage(
        slug = "harry-potter",
        blurb = "Wondering whether Harry Potter is suitable for Muslim children? Fitrah Filter checks books, movies, and shows against Islamic values. Here's what parents should know before handing it over.",
    )
}
